async function fetchAllDealers() {
  const endpoint = "https://emmo-ca.myshopify.com/api/2025-01/graphql.json";
  const token = "d55e296da27c29b9b00cb0912739b557";

  const query = `
    query getDealers($cursor: String) {
      metaobjects(type: "dealer", first: 250, after: $cursor) {
        edges {
          node {
            id
            handle
            name: field(key: "name") { value }
            city: field(key: "city") { value }
            province: field(key: "province") { value }
            latitude: field(key: "latitude") { value }
            longitude: field(key: "longitude") { value }
            address: field(key: "address") { value }
            address_2: field(key: "address_2") { value }
            website: field(key: "website") { value }
            postal_code: field(key: "postal_code") { value }
            phone: field(key: "phone") { value }
            email: field(key: "email") { value }
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }
  `;

  let hasNext = true;
  let cursor = null;
  let dealers = [];

  while (hasNext) {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token,
      },
      body: JSON.stringify({ query, variables: { cursor } }),
    });
    if (!res.ok) {
      const text = await res.text();
      console.error("Dealer fetch HTTP error:", res.status, text);
      throw new Error(`Dealer fetch failed with status ${res.status}`);
    }
    const json = await res.json();
    if (json.errors) {
      console.error("Dealer fetch GraphQL errors:", json.errors);
      throw new Error("Failed to fetch dealers");
    }
    const data = json.data?.metaobjects;
    if (!data) {
      throw new Error("Invalid dealer response format");
    }
    dealers.push(
      ...data.edges.map(({ node }) => ({
        id: node.id,
        handle: node.handle,
        name: node.name?.value || "",
        city: node.city?.value || "",
        province: node.province?.value || "",
        latitude: node.latitude?.value || "",
        longitude: node.longitude?.value || "",
        address: node.address?.value || "",
        address_2: node.address_2?.value || "",
        website: node.website?.value || "",
        postal_code: node.postal_code?.value || "",
        phone: node.phone?.value || "",
        email: node.email?.value || "",
      })),
    );
    hasNext = data.pageInfo.hasNextPage;
    cursor = data.pageInfo.endCursor;
  }

  return dealers;
}

async function fetchAllHelpCenterProducts() {
  const endpoint = "https://emmo-ca.myshopify.com/api/2025-01/graphql.json";
  const token = "d55e296da27c29b9b00cb0912739b557";

  const query = `
    query getHelpCenterProducts($cursor: String) {
      metaobjects(type: "help_center_product", first: 250, after: $cursor) {
        edges {
          node {
            id
            handle
            type
            title: field(key: "title") { value }
            collection: field(key: "collection") {
              value
              reference {
                ... on Collection {
                  id
                  title
                }
              }
            }
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }
  `;

  let hasNext = true;
  let cursor = null;
  let products = [];

  while (hasNext) {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token,
      },
      body: JSON.stringify({ query, variables: { cursor } }),
    });
    if (!res.ok) {
      const text = await res.text();
      console.error("Help center product fetch HTTP error:", res.status, text);
      throw new Error(`Help center product fetch failed with status ${res.status}`);
    }
    const json = await res.json();
    if (json.errors) {
      console.error("Help center product fetch GraphQL errors:", json.errors);
      throw new Error("Failed to fetch help center products");
    }
    const data = json.data?.metaobjects;
    if (!data) {
      throw new Error("Invalid help center product response format");
    }
    products.push(
      ...data.edges.map(({ node }) => {
        const collectionId =
          node.collection?.reference?.id || node.collection?.value || "";
        const collectionTitle = node.collection?.title || "";

        return {
          id: node.id,
          handle: node.handle,
          title: node.title?.value || "",
          url: node.handle && node.type ? `/metaobjects/${node.type}/${node.handle}` : "",
          collection: {
            value: {
              id: collectionId,
              title: collectionTitle,
            },
          },
        };
      }),
    );
    hasNext = data.pageInfo.hasNextPage;
    cursor = data.pageInfo.endCursor;
  }

  const missingTitleIds = Array.from(
    new Set(
      products
        .filter((product) => !product.collection.value.title && product.collection.value.id)
        .map((product) => product.collection.value.id),
    ),
  );

  if (missingTitleIds.length) {
    const chunks = [];
    for (let i = 0; i < missingTitleIds.length; i += 100) {
      chunks.push(missingTitleIds.slice(i, i + 100));
    }

    for (const chunk of chunks) {
      const collectionQuery = `
        query getCollections($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Collection {
              id
              title
            }
          }
        }
      `;

      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": token,
        },
        body: JSON.stringify({ query: collectionQuery, variables: { ids: chunk } }),
      });
      if (!res.ok) {
        const text = await res.text();
        console.error("Collection fetch HTTP error:", res.status, text);
        throw new Error(`Collection fetch failed with status ${res.status}`);
      }
      const json = await res.json();
      if (json.errors) {
        console.error("Collection fetch GraphQL errors:", json.errors);
        throw new Error("Failed to fetch collections");
      }
      const nodes = json.data?.nodes || [];
      const titleById = nodes.reduce((acc, node) => {
        if (node && node.id) acc[node.id] = node.title || "";
        return acc;
      }, {});

      products.forEach((product) => {
        const id = product.collection.value.id;
        if (!product.collection.value.title && titleById[id]) {
          product.collection.value.title = titleById[id];
        }
      });
    }
  }

  return products;
}

async function fetchAllFeaturedFaqItems() {
  const endpoint = "https://emmo-ca.myshopify.com/api/2025-01/graphql.json";
  const token = "d55e296da27c29b9b00cb0912739b557";

  const query = `
    query getFeaturedFaqItems($cursor: String) {
      metaobjects(type: "faq_items", first: 250, after: $cursor) {
        edges {
          node {
            id
            handle
            question: field(key: "question") { value }
            answer: field(key: "answer") { value }
            featured: field(key: "featured") { value }
            active: field(key: "active") { value }
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }
  `;

  let hasNext = true;
  let cursor = null;
  let items = [];

  while (hasNext) {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token,
      },
      body: JSON.stringify({ query, variables: { cursor } }),
    });
    if (!res.ok) {
      const text = await res.text();
      console.error("FAQ fetch HTTP error:", res.status, text);
      throw new Error(`FAQ fetch failed with status ${res.status}`);
    }
    const json = await res.json();
    if (json.errors) {
      console.error("FAQ fetch GraphQL errors:", json.errors);
      throw new Error("Failed to fetch faq items");
    }
    const data = json.data?.metaobjects;
    if (!data) {
      throw new Error("Invalid faq response format");
    }
    items.push(
      ...data.edges.map(({ node }) => ({
        id: node.id,
        handle: node.handle,
        question: node.question?.value || "",
        answer: node.answer?.value || "",
        featured: node.featured?.value || "",
        active: node.active?.value || "",
      })),
    );
    hasNext = data.pageInfo.hasNextPage;
    cursor = data.pageInfo.endCursor;
  }

  return items.filter((item) => {
    const featured = item?.featured;
    return featured === true || featured === "true" || featured === "1";
  });
}

if (typeof window !== "undefined") {
  window.fetchAllDealers = fetchAllDealers;
  window.fetchAllHelpCenterProducts = fetchAllHelpCenterProducts;
  window.fetchAllFeaturedFaqItems = fetchAllFeaturedFaqItems;
}
